import { receivableStatus } from './receivableStatus';

export const receivableStatusName = {
  [receivableStatus.RECEIVED]: 'Recebido',
  [receivableStatus.PENDING]: 'Pendente',
  [receivableStatus.CANCELED]: 'Cancelado',
  [receivableStatus.REFUNDED]: 'Devolvido',
  [receivableStatus.PARTIALLY_REFUNDED]: 'Parcialmente devolvido'
};
